export const environment = {
  appTitle: "Fraunhofer Empower",
  appVersion: "1.5.1",
  name: 'fraunhofer-future-lab',
  production: true,
  applicationUrl: "https://fraunhofer.digital-worx.de",
  supabaseUrl: "https://hugbojstdrkwmgzhcyzz.supabase.co",
  supabaseProjectId: "hugbojstdrkwmgzhcyzz",
  supabaseKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1Z2JvanN0ZHJrd21nemhjeXp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE4MTE3NjEsImV4cCI6MjA3NzM4Nzc2MX0.QQSTev9wOKb-uBhe2vdgUhvOf8QyXcga-zohRpHESrg",
  supabaseEdgeFunctionEndpoint: 'https://hugbojstdrkwmgzhcyzz.supabase.co.supabase.co/functions/v1',
  authEmail: "@fraunhofer.digital-worx.de",
  editorAiPluginLabel: "FraunhoferGPT",
  editorAiPluginEndpoint: "https://qundisgpt-apa4b3ehhtdrdbcf.germanywestcentral-01.azurewebsites.net/Chat",
  deletedSystemUserUuid: "1168c613-826b-4755-8e55-19b74d7e053c"
};
